import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client'
import { BatchHttpLink } from '@apollo/client/link/batch-http'
import { onError } from '@apollo/client/link/error'

// Middleware to handle authentication tokens
const authLink = new ApolloLink((operation, forward) => {
  const tokenElm = document.querySelector('meta[name=auth-token]')
  const token = tokenElm ? tokenElm.getAttribute('content') : null
  const { headers = {} } = operation.getContext()

  // add the authorization to the headers
  operation.setContext({
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  })

  return forward(operation)
})

// Middleware to handle batch responses
const afterwareLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    if (response.payload && response.payload.data) {
      response.data = response.payload.data
    }
    return response
  })
})

// Error handling link
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    )
  }
  if (networkError) console.log(`[Network error]: ${networkError}`)
})

const httpLink = new BatchHttpLink({
  uri: '/graphql',
  batchMax: 5,
  batchInterval: 20,
})

// Combine the links
const link = new ApolloLink.from([authLink, errorLink, afterwareLink, httpLink])

// Create the Apollo Client
const client = new ApolloClient({
  uri: '/graphql',
  link,
  cache: new InMemoryCache(),
})

export default client
